import React from "react";
import {Ripple} from "../../../../../Buttons";
import Cross from "../../../../../../icons/Cross";

export default ({onClick}) => (
  <div className="merchant-upload__item-delete">
    <Ripple onClick={onClick}>
      <Cross />
    </Ripple>
  </div>
);
